const t = {
  bg:       '#0e0e0d',
  surface:  '#161614',
  surface2: '#1c1b19',
  surface3: '#222220',
  border:      '#2a2927',
  borderLight: '#333230',
  text:  '#f0ede8',
  text2: '#a8a49e',
  text3: '#6b6966',
  accent:      '#c49a3c',
  accentDark:  '#9d7a2e',
  accentLight: 'rgba(196,154,60,0.12)',
  accentBorder:'rgba(196,154,60,0.25)',
  green:       '#4caf7d',
  greenLight:  'rgba(76,175,125,0.12)',
  red:         '#e05252',
  redLight:    'rgba(224,82,82,0.12)',
  blue:        '#5b9bd5',
  blueLight:   'rgba(91,155,213,0.12)',
  orange:      '#d4845a',
  orangeLight: 'rgba(212,132,90,0.12)',
  purple:      '#9b7fd4',
  purpleLight: 'rgba(155,127,212,0.12)',
  r:  '8px', r2: '12px', r3: '16px',
  shadow:   '0 1px 3px rgba(0,0,0,0.4)',
  shadowMd: '0 4px 16px rgba(0,0,0,0.5)',
  shadowLg: '0 8px 32px rgba(0,0,0,0.6)',
  font:      "'DM Sans','Helvetica Neue',sans-serif",
  fontSerif: "'DM Serif Display',Georgia,serif",
  card:         { background:'#161614', borderRadius:'12px', border:'1px solid #2a2927', boxShadow:'0 1px 3px rgba(0,0,0,0.4)' },
  input:        { padding:'10px 14px', borderRadius:'8px', border:'1px solid #2a2927', fontSize:'14px', color:'#f0ede8', background:'#1c1b19', outline:'none', fontFamily:"'DM Sans',sans-serif" },
  select:       { padding:'10px 14px', borderRadius:'8px', border:'1px solid #2a2927', fontSize:'14px', color:'#f0ede8', background:'#1c1b19', outline:'none', fontFamily:"'DM Sans',sans-serif", cursor:'pointer' },
  textarea:     { padding:'10px 14px', borderRadius:'8px', border:'1px solid #2a2927', fontSize:'14px', color:'#f0ede8', background:'#1c1b19', outline:'none', fontFamily:"'DM Sans',sans-serif", resize:'vertical' },
  btnPrimary:   { background:'#c49a3c', color:'#0e0e0d', border:'none', padding:'10px 20px', borderRadius:'8px', fontSize:'13px', fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" },
  btnSecondary: { background:'#1c1b19', color:'#a8a49e', border:'1px solid #2a2927', padding:'10px 20px', borderRadius:'8px', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" },
  btnDanger:    { background:'rgba(224,82,82,0.12)', color:'#e05252', border:'1px solid rgba(224,82,82,0.25)', padding:'10px 20px', borderRadius:'8px', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" },
  overlay:      { position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:'20px', backdropFilter:'blur(4px)' },
  modal:        { background:'#161614', borderRadius:'16px', border:'1px solid #2a2927', width:'100%', maxWidth:'580px', maxHeight:'90vh', overflow:'hidden', display:'flex', flexDirection:'column', boxShadow:'0 8px 32px rgba(0,0,0,0.6)' },
  modalHeader:  { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'20px 24px', borderBottom:'1px solid #2a2927' },
  modalTitle:   { margin:0, fontSize:'16px', fontWeight:600, color:'#f0ede8', letterSpacing:'-0.2px' },
  closeBtn:     { background:'#1c1b19', border:'1px solid #2a2927', borderRadius:'6px', padding:'5px 9px', cursor:'pointer', fontSize:'14px', color:'#a8a49e', fontWeight:600 },
  modalBody:    { padding:'24px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'16px' },
  modalFooter:  { display:'flex', justifyContent:'flex-end', gap:'10px', padding:'16px 24px', borderTop:'1px solid #2a2927' },
  label:        { fontSize:'11px', fontWeight:600, color:'#6b6966', textTransform:'uppercase', letterSpacing:'0.6px' },
  fieldGroup:   { display:'flex', flexDirection:'column', gap:'7px' },
  errorBox:     { background:'rgba(224,82,82,0.1)', border:'1px solid rgba(224,82,82,0.25)', borderRadius:'8px', padding:'10px 14px', fontSize:'13px', color:'#e05252' },
};
export default t;
